import { ComponentsNameParser } from "./components-name";
import { DataTemplatesNameParser } from "./data-templates-names";
import { DataPacksCategoryParser, DataPacksParser } from "./datapacks";
import { FormCategoryNamesParser } from "./form-categories-name";
import { FormFieldsParser } from "./form-fields";
import { FormTemplatesParser } from "./form-templates";
import { LanguagesParser } from "./languages";
import { MenuItemsParser } from "./menu-items";
import { ModuleCateogiresParser } from "./module-categories";
import { ModulesNameParser } from "./modules-name";
import { PageContentTypeParser } from "./page-data";
import { PageDataPropsParser } from "./page-data-props";
import { SimpleContentTypeParser } from "./simple-data";
import { SimpleDataPropsParser } from "./simple-data-props";
import { TaxonomyParser } from "./taxonomy";
import { TaxonomyPropsParser } from "./taxonomy-props";
import { TemplateSectionListParser } from "./template-section-list";
import { TemplatesNameParser } from "./templates-name";
import { SubthemesParser, ThemesParser } from "./themes";
import { UIAndDataPropsParser } from "./ui-data-props";

export const parsers = {
	ComponentsNameParser,
	DataPacksCategoryParser,
	DataPacksParser,
	DataTemplatesNameParser,
	FormCategoryNamesParser,
	FormFieldsParser,
	FormTemplatesParser,
	LanguagesParser,
	MenuItemsParser,
	ModuleCateogiresParser,
	ModulesNameParser,
	PageContentTypeParser,
	PageDataPropsParser,
	SimpleContentTypeParser,
	SimpleDataPropsParser,
	SubthemesParser,
	TaxonomyParser,
	TaxonomyPropsParser,
	TemplateSectionListParser,
	TemplatesNameParser,
	ThemesParser,
	UIAndDataPropsParser,
};
